module.exports = __webpack_public_path__ + "static/img/loading1.8928453b.gif";